import { render, staticRenderFns } from "./AudioClip.vue?vue&type=template&id=53e54092&scoped=true"
import script from "./AudioClip.vue?vue&type=script&lang=ts"
export * from "./AudioClip.vue?vue&type=script&lang=ts"
import style0 from "./AudioClip.vue?vue&type=style&index=0&id=53e54092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e54092",
  null
  
)

export default component.exports